import { render, staticRenderFns } from "./FabricDialog.vue?vue&type=template&id=ec1dda80&scoped=true&"
import script from "./FabricDialog.vue?vue&type=script&lang=js&"
export * from "./FabricDialog.vue?vue&type=script&lang=js&"
import style0 from "./FabricDialog.vue?vue&type=style&index=0&id=ec1dda80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1dda80",
  null
  
)

export default component.exports